import { ready } from '~/core'
import addEvents from '~/utils/addEvents'
ready('print-button', '.print_button', (printButton) => {
    if (printButton) {
        addEvents(printButton, 'click.prevent', (e) => {
            window.print();
        })
    }
})